<template>
  <header class="header">
    <div class="page">
      <NuxtLink to="/" class="branding"><img src="/images/LogoPlopPuerca.png" alt="logo" ></NuxtLink>
      <nav>
        <button aria-label="menu" class="bt_menu"><i class="fas fa-bars"/><span>Desplegar menú</span></button>
        <ul v-if="config.PRODUCTION_READY">
          <li v-if="!session.session.loggedIn">
            <NuxtLink to="/auth/login"><i class="fa-solid fa-ticket"/>{{$t('navigation.myTickets')}}</NuxtLink>
          </li>
          <li v-if="session.session.loggedIn">
            <NuxtLink href="#" to="/user/profile" class="user">
              <i class="fa fa-circle-user"/>
            </NuxtLink>
          </li>
          <li v-if="session.session.loggedIn">
            <NuxtLink to="/user/reservations"><i class="fa-solid fa-ticket"/>{{$t('navigation.myTickets')}}</NuxtLink>
          </li>
        </ul>
        <ul v-else/>
        <social-links/>
      </nav>
    </div>
    <!--  <modal-component ref="doubtsModal" :title="$t('navigation.aboutUs')">-->
    <!--    <p>{{$t('navigation.modalDoubts')}}</p>-->
    <!--    <p>{{$t('navigation.modalDoubts2')}}</p>-->
    <!--  </modal-component>-->
  </header>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import {useSessionStore} from "~/storage/session";
import api from "~/api";
import useConfig from "~/config/useConfig";

export default defineComponent({
  name: 'Navigation',
  components: {},
  data() {
    return {
      isMenuOpen: false,
      session: useSessionStore(),
      config: useConfig()
    }
  },
  computed: {
    menuClass() {
      return this.isMenuOpen ? 'menu visible' : 'menu'
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    async logout() {
      await api.Auth.logout()
      const sessionStore = useSessionStore();
      sessionStore._reset();

      window.location = '/'
    }
  }
})
</script>
